<div class="profile-list" *ngIf="profiles">
  <ft-profile-tile *ngFor="let profile of profiles" [profile]="profile">
  </ft-profile-tile>
</div>
